import React, { useEffect, useState } from 'react'
import './SubscriptionDetails.css'
import { useDispatch, useSelector } from 'react-redux'
import { FetchSubscription } from '../../appActions'
import { useNavigate } from 'react-router-dom'
import callApi from '../../util/callApi'
import ChangePasswordForm from '../../Components/ChangePasswordForm'
import storageService from '../../util/storageService'
import configVariables from '../../util/constants'
import InvoicePDF from '../../Components/Invoice'
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import InfoIcon from '@mui/icons-material/Info';

function SubscriptionDetails() {

  const state = useSelector((state) => state)
  const dispatch = useDispatch()
  const nav = useNavigate()
  const [changePasswordModal, setChangePasswordModal] = useState(false)

  useEffect(() => {
    if (!state.subscription) {
      dispatch(FetchSubscription())
    }
  }, [])



  const handlePasswordChange = () => {
    setChangePasswordModal(true)
  }
  const handleDownload = async (invoice) => {
    console.log('user',state.subscription.user)
    console.log('invoice', invoice)
    const formattedDate = new Intl.DateTimeFormat('en-GB').format(new Date(invoice.createdAt));
    const invoiceData = {
      customerName: state?.subscription?.user?.username || "N/A",
      invoiceId: invoice._id,
      customerMail: state?.subscription?.user?.contact_email || "N/A",
      customerPhone: state?.subscription?.user?.phone_number || "N/A",
      planName: invoice.plan,
      quantity: invoice.devices?.length || 1, // fallback to 1 if devices not available
      total: (invoice.amount).toFixed(2),
      paidDate: formattedDate,
    };
    const blob = await pdf(<InvoicePDF invoice={invoiceData} />).toBlob();
    saveAs(blob, `invoice_${invoice._id}.pdf`);
  };
  const filteredDevices = state?.subscription?.devices?.filter(device => {
    const hasSub = !!device.subscriptionId && device.subscriptionId !== '';
    const validUpto = device.payment?.validUpto;
    const isExpired = !validUpto || new Date(validUpto) <= new Date();
  
    return !hasSub || isExpired;
  }) || [];


  return (
    <>
      {/* Main section with subscription details */}
      <div className="main sub-det-main containor">
      <div className="sub-det-card-top">
  <div className="sub-det-card">
    <div className="sub-det-card-head">
      <h2 className="card-title">Profile</h2>
    </div>
    <div className="sub-det-card-cont">
      <p className="card-period">Username: <span>{state?.subscription?.user?.username}</span></p>
      <p className="card-period">Email: <span>{state?.subscription?.user?.contact_email}</span></p>
      <p className="card-period">Phone: <span>{state?.subscription?.user?.phone_number}</span></p>
      <p className="card-period">Role: <span>{state?.subscription?.user?.userRole}</span></p>
      {state?.subscription?.user?.userRole === 'owner' && (
        <p className="card-period">UserAccount Left: <span>{state?.user_det?.userAccounts}</span></p>
      )}
    </div>
    <button onClick={handlePasswordChange} className="cancel-btn">
      Change Password
    </button>
    <br /><br />
   
  <div>
    <button
      className="recharge-btn"
      onClick={() => {
        nav('/pay', { state: { devices: state?.subscription?.devices ,User:state?.user_det} });
      }}
    >
      Recharge For All Devices
    </button>
  </div>



  </div>

  {state?.subscription?.devices?.length > 0 &&state.user_det? (
    state.subscription.devices.map((device, index) => {
      const isAutoPayEnabled = device.subscriptionId && new Date(device.payment?.validUpto) > new Date();
      return (
        <div key={device._id || index} className="sub-det-card">
          <div className="sub-det-card-head">
            <h2 className="card-title">{device.payment?.planName || "No Plan"}</h2>
            <p className={`card-status ${device.payment?.status === "active" ? "active" : "inactive"}`}>
              {device.payment?.status }
            </p>
          </div>
          <div className="sub-det-card-cont">
            <p className="card-period"><span>Device: {device.name}</span></p>
            <p className="card-period"><span>Serial No: {device.serial_no}</span></p>
            <p className="card-period">
              <span>Expiry: {device.payment?.validUpto ? new Date(device.payment.validUpto).toDateString() : "N/A"}</span>
            </p>
            <p className="card-period"><span>Data Left: {device.payment?.dataUsage}</span></p>
          </div>

          {isAutoPayEnabled && (
              <div className="autopay-note">
                <InfoIcon style={{ marginRight: '8px', color: '#4caf50' }} />
                You have enabled autopay. Wait till expiry to recharge manually.
              </div>
            )}
            <br />

            <button
              className="recharge-btn"
              onClick={() => {
                nav('/pay', { state: { device, User: state?.user_det } });
              }}
            >
              Recharge
            </button>


        </div>
      );
    })
  ) : (
    <p>No devices available.</p>
  )}
</div>

  
        {/* Table of previous invoices */}
        {state?.subscription?.billing?.length > 0 && (
          <div className="invoices-table device-table ">
            <div className='table-row sub-det-table-row'>
              
              <p>Plan</p>
              <p>Date</p>
              <p>Amount</p>
              <p>Download Invoice</p>
              
            </div>
            {state?.subscription?.billing.map((invoice) => (
              <div key={invoice._id} className='table-row sub-det-table-row'>
                <p>{invoice.plan}</p>
                <p>{new Date(invoice.createdAt).toLocaleDateString()}</p>
                <p>{(invoice.amount ).toFixed(2)} INR</p>
                <p className="paid inv-status" style={{ cursor: "pointer", color: "blue" }} onClick={() => handleDownload(invoice)}>
            Download
          </p>
              </div>
            ))}
          </div>
        )}
      </div>
  
      {changePasswordModal && (
        <ChangePasswordForm 
          user_email={state?.subscription?.user?.contact_email} 
          setCloseModal={setChangePasswordModal} 
        />
      )}
    </>
  );
  
}

export default SubscriptionDetails